/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HighRiskModel } from './HighRiskModel';
import {
    HighRiskModelFromJSON,
    HighRiskModelFromJSONTyped,
    HighRiskModelToJSON,
    HighRiskModelToJSONTyped,
} from './HighRiskModel';

/**
 * 
 * @export
 * @interface HighRiskServiceGetResponse
 */
export interface HighRiskServiceGetResponse {
    /**
     * 
     * @type {Array<HighRiskModel>}
     * @memberof HighRiskServiceGetResponse
     */
    highRisks?: Array<HighRiskModel> | null;
}

/**
 * Check if a given object implements the HighRiskServiceGetResponse interface.
 */
export function instanceOfHighRiskServiceGetResponse(value: object): value is HighRiskServiceGetResponse {
    return true;
}

export function HighRiskServiceGetResponseFromJSON(json: any): HighRiskServiceGetResponse {
    return HighRiskServiceGetResponseFromJSONTyped(json, false);
}

export function HighRiskServiceGetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HighRiskServiceGetResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'highRisks': json['highRisks'] == null ? undefined : ((json['highRisks'] as Array<any>).map(HighRiskModelFromJSON)),
    };
}

export function HighRiskServiceGetResponseToJSON(json: any): HighRiskServiceGetResponse {
    return HighRiskServiceGetResponseToJSONTyped(json, false);
}

export function HighRiskServiceGetResponseToJSONTyped(value?: HighRiskServiceGetResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'highRisks': value['highRisks'] == null ? undefined : ((value['highRisks'] as Array<any>).map(HighRiskModelToJSON)),
    };
}

